export enum RiderEventType {
  finished = 'Finished',
  started = 'Started'
}
